import { useAccount } from './useAccount';

export const useUserIsOrgPowerUser = () => {
  const accountQuery = useAccount();
  if (accountQuery.isSuccess) {
    return {
      ...accountQuery,
      data: accountQuery.data.user.roles.some(
        (role) => role.name === 'Power User'
      ),
    };
  } else {
    // Return account query status if data is not yet fetched
    return {
      ...accountQuery,
      data: undefined,
    };
  }
};
